import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TimePickerData } from 'shared/components/chat-messages/time-picker/time-picker.model';
import * as moment from 'moment';

@Component({
  selector: 'time-picker-message',
  templateUrl: './time-picker-message.component.html',
  styleUrls: ['./time-picker-message.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TimePickerMessageComponent {
  public timePicker: TimePickerData;

  @Input() direction: string;
  @Input() set timePickerJson(json: string) {
    this.timePicker = JSON.parse(json);
  }

  readonly daysOfWeek: { [dayInt: number]: string } = {
    0: 'timePickerMessage.sunday',
    1: 'timePickerMessage.monday',
    2: 'timePickerMessage.tuesday',
    3: 'timePickerMessage.wednesday',
    4: 'timePickerMessage.thursday',
    5: 'timePickerMessage.friday',
    6: 'timePickerMessage.saturday'
  };

  public getTimeSlotTitle(timeslotDateTime: number): string {
    const timeslotDateFormatted = this.formatDate(timeslotDateTime);
    if (moment().format('l') === timeslotDateFormatted) {
      return 'timePickerMessage.today';
    } else if (moment().add(1, 'days').format('l') === timeslotDateFormatted) {
      return 'timePickerMessage.tomorrow';
    } else {
      const dayInt = parseInt(moment(timeslotDateTime).format('e'), 10);
      return !isNaN(dayInt) ? this.daysOfWeek[dayInt] : '';
    }
  }

  public formatTime(dateTime: number) {
    return moment(dateTime).format('LT');
  }

  public formatDate(dateTime: number) {
    return moment(dateTime).format('l');
  }
}
